import React, { useState } from "react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import {
    HiHeart,
  HiOutlineHeart,
} from "react-icons/hi";
import BookingModal from "../BookingModal/BookingModal";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import CardLoading from "../Spinner/CardLoading";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const [booking, setBooking] = useState(null);
  const [wishlistLoading, setWishlistLoading] = useState(false);

  const handleReport = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}/products/reported/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Make report successful.");
          // setIsLoading(false)
        }
      });
  };

  const handleWishlist = (id) => {
    setWishlistLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/wishlist/add/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setWishlistLoading(false);
          toast.success(data.message);
        } else {
          setWishlistLoading(false);
          toast.error(data.message);
        }
      });
  };

  const {
    data: user = [],
    isLoading,
  } = useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/user/seller/${product.host.email}`
      );
      const data = await res.json();
      return data;
    },
  });

  if (isLoading) {
    return <CardLoading />;
  }

  return (
    <div>
      <div className="card w-80 bg-base-100 shadow-xl relative">
        <button
          onClick={() => handleWishlist(product._id)}
          className="btn btn-ghost btn-sm absolute top-4 right-5 z-10">
          {wishlistLoading ? (
            <HiHeart className="w-8 h-8 text-red-700 cursor-pointer" />
          ) : (
            <HiOutlineHeart className="w-8 h-8 cursor-pointer" />
          )}
        </button>
        <figure><img src={product.img} alt={product.title} className="h-60 w-full" /></figure>
        <div className="card-body bg-white dark:bg-slate-900 p-4">
          <h2 className="card-title">{product.title}</h2>
          <div className="product-details text-sm">
            <p className="mt-1">Location: {product.location}</p>
            <div className="flex justify-between">
              <p className="mt-1">ResellerPrice: {product.resellerPrice}</p>
              <p className="mt-1">OriginalPrice: {product.originalPrice}</p>
            </div>
            <p className="mt-1">Year Of Used: {product.yearOfUsed}</p>
            <p className="mt-1">Posted: {product.post_time}</p>
            <div className="flex mt-1 justify-between">
              <span>Author: {product?.seller_name}</span>
              {product?.seller_isVerified === true ? (
                <span className="flex">
                  Verify:{" "}
                  <AiOutlineCheckCircle className="ml-2 h-6 w-6 text-green-500" />
                </span>
              ) : (
                <span className="flex">
                  Verify:{" "}
                  <AiOutlineCloseCircle className="ml-2 h-6 w-6 text-red-500" />
                </span>
              )}
            </div>
          </div>
          <div className="card-actions justify-between">
            {product.sold === false ? (
              <label
                className="btn btn-primary"
                htmlFor="booking-modal"
                onClick={() => setBooking(product)}>
                Book Now
              </label>
            ) : (
              <label className="btn btn-true disabled">Sold</label>
            )}
            <label
              className="btn btn-primary btn-xs"
              onClick={() => handleReport(product._id)}>
              Report
            </label>
          </div>
        </div>
      </div>
      {booking && <BookingModal booking={booking} setBooking={setBooking} />}
    </div>
  );
};

export default ProductCard;
